<template>
  <CardContainer>
    <template v-slot:title>
      {{ text.pages.cart.choosePaymentType }}
    </template>
    <template v-slot:content>
      <v-container fluid>
        <v-row align="center">
          <v-col class="d-flex" cols="12" sm="6">
            <v-select
              v-model="payment"
              :items="paymentTypes"
              item-value="id"
              item-text="name"
              dense
              @change="setPayment"
              :disabled="currentStep > viewStep"
            ></v-select>
          </v-col>
        </v-row>
      </v-container>
    </template>
    <template v-slot:action>
      <CartActionButtons :current-step="currentStep" :view-step="viewStep"
                         v-on:back="$emit('back')" v-on:confirm="$emit('confirm');
$store.commit('updateOrderData', {payment: payment})"
                         :hideConfirm="hideConfirm"
      />
    </template>
  </CardContainer>
</template>

<script>
import { translations } from '@/lang/translations';
import Axios from '@/core/Axios';
import CardContainer from '@/components/Partials/CardContainer.vue';
import CartActionButtons from '@/components/Pages/CartActionButtons.vue';
import { state } from '../../store/index';

export default {
  name: 'CartPayment',
  components: { CardContainer, CartActionButtons },
  props: ['currentStep'],
  data() {
    return {
      payment: null,
      paymentTypes: [],
      axios: new Axios(),
      viewStep: 4,
      hideConfirm: true,
    };
  },
  mounted() {
    this.getDeliveryTypes();
  },
  computed: {
    text() {
      return translations[state.language];
    },
  },
  methods: {
    getDeliveryTypes() {
      this.axios
        .makeCall('GET', 'norbit/payment')
        .then((response) => {
          if (response) {
            this.paymentTypes = response;
          }
        })
        .catch(() => {
          this.$store.commit('showSnackbar', {
            type: 'error',
            message:
            this.text.messages.loadDataError,
          });
        });
    },
    setPayment(e) {
      this.hideConfirm = false;
      this.$emit('setPayment', e);
    },
  },
};
</script>

<style scoped>

</style>
